<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Jenis & Harga Iklan
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(index)="data">
          {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
        </template>
        <template v-slot:cell(classad)="data">
          <span v-if="(data.item.classad)">KOLOM/CLASS AD</span>
          <span v-else>IKLAN UMUM</span>
        </template>

        <template v-slot:cell(hargabw)="data">
          {{data.item.hargabw|numFormat}}
        </template>

        <template v-slot:cell(hargafc)="data">
          {{data.item.hargafc|numFormat}}
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing
            {{(tblData.page - 1) * tblData.limit + 1}}
            to
            {{tblData.page * tblData.limit}}
            of
            {{tblData.total}}
            entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page"  style="margin-top:0 !important;">
            <b-form-select :options="[10, 15, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-form-group>
        </b-col>        

        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card >
          <div slot="header">Jenis & Harga Iklan - Add/Edit Form 
          </div>
                <b-input-group >
                    <b-input-group-prepend><label>Jenis Iklan</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.jenisiklan" :state="!$v.frmdata.jenisiklan.$error"></b-form-input>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label> &nbsp;&nbsp;&nbsp;</label></b-input-group-prepend>
                    <b-form-radio-group  v-model="frmdata.classad" name="clasAdvertising" class="ml-1 mt-1" :state="!$v.frmdata.classad.$error">
                        <b-form-radio :value="0">Iklan Umum</b-form-radio>
                        <b-form-radio :value="1">Kolom/Class Ad.</b-form-radio>
                    </b-form-radio-group>
                    <b-form-checkbox :value="1" :unchecked-value="0" v-model="frmdata.classad" class="mt-1">Iklan Baris</b-form-checkbox>
                </b-input-group>

                <b-input-group >
                    <b-input-group-prepend><label>Uraian</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.uraian" :state="!$v.frmdata.uraian.$error" ></b-form-input>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label>Harga Black&White</label></b-input-group-prepend>
                        <b-input-group-prepend>
                            <span class="input-group-text">{{uanguser}}</span>
                        </b-input-group-prepend>
                        <my-number class="form-control text-right" v-model="frmdata.hargabw" :precision="2" ></my-number>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label>Harga Full Color</label></b-input-group-prepend>
                        <b-input-group-prepend>
                            <span class="input-group-text">{{uanguser}}</span>
                        </b-input-group-prepend>
                        <my-number class="form-control text-right" v-model="frmdata.hargafc" :precision="2" ></my-number>
                </b-input-group>
                
            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
              <b-button class="btn btn-danger mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>

        </b-card>
        </b-col>
    </b-row>
  </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 160px;
            }
        }
    }
</style>


<script>
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import myNumber from "../../components/my-number";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        jenisiklan: { required },
        uraian: { required },
        classad: { required },
    },
  }, 
  components:{myNumber},
  data() {
    return {
      showDelConfirm: false,
      showList:true,
      showForm:false,
      uanguser: this.$store.state.user.matauang,
      frmdata:{jenisiklan: '',uraian:'', hargabw:0, hargafc:0 },
      tblData: {
        tablename:'jenisiklankoran',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'jenisiklan',
        sortDesc: false
      },
    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "index",
            label: "No.",
          },
          {
            key: "jenisiklan",
            label: "Jenis Iklan",
            sortable: true
          },
          {
            key: "classad",
            label: "",
            sortable: true
          },
          {
            key: "uraian",
            label: "Description",
            sortable: true
          },
          {
            key: "hargabw",
            label: "Harga BW",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "hargafc",
            label: "Harga FC",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await crud.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.frmdata.idlama = data.jiklanid;
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              if (this.frmdata.idlama) {
                await crud.update(
                     {tablename:'jenisiklankoran', 
                     key:this.frmdata.idlama, 
                     data:{jenisiklan:this.frmdata.jenisiklan, uraian:this.frmdata.uraian,classad:this.frmdata.classad, hargabw:this.frmdata.hargabw,hargafc:this.frmdata.hargafc, baris:this.frmdata.baris}
                      });
              } else {
                await crud.insert(
                  { tablename:'jenisiklankoran',                      
                     data:{jenisiklan:this.frmdata.jenisiklan, uraian:this.frmdata.uraian,classad:this.frmdata.classad, hargabw:this.frmdata.hargabw,hargafc:this.frmdata.hargafc, baris:this.frmdata.baris}
                  });
              }
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({tablename:'jenisiklankoran', key:this.model.jiklanid});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push({name: "iklankoran.home"});
    },    
  }
};
</script>
